module.exports = __webpack_public_path__ + "static/media/interface.a8e81268.svg";